import { createContext, useContext } from 'react';
import { Photo } from '../graphql/graphql';

export interface PageProps {
  mainPageImage?: Photo;
}

export const PageContext = createContext<PageProps>({
  mainPageImage: {}
});

export const usePageProps = () => useContext(PageContext);
